import { TabletOperationMode } from "api/types";
import App from "App";
import { CustomerDataContext } from "components/Gates/CustomerDataGate";
import { TabletDataContext } from "components/Gates/TabletDataGate";
import { History } from "history";
import * as React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import AuthorizationAccept from "screens/Authorization/accept";
import AuthorizationManage from "screens/Authorization/manage";
import AuthorizationPairing from "screens/Authorization/pairing";
import Budtender from "screens/Budtender/";
import CompletePurchase from "screens/CompletePurchase";
import Congrats from "screens/Congrats";
import Kiosk from "screens/Kiosk";
import KioskWelcome from "screens/Kiosk/Welcome";
import KioskWelcomeToLocation from "screens/Kiosk/WelcomeToLocation";
import BlockchainProfile from "screens/Main/edit-profile/blockchain/blockchainProfile";
import ChangePin from "screens/Main/edit-profile/changePin";
import EditCustomerPersonalInfo from "screens/Main/edit-profile/EditCustomerPersonalInfo";
import EditInterestSelection from "screens/Main/edit-profile/EditInterestSelection";
import EditUsageTypeSelection from "screens/Main/edit-profile/EditUsageTypeSelection";
import Main from "screens/Main/MainDashboard";
import NewAtLocationTcpaAcknowledgement from "screens/Onboarding/NewAtLocation/NewAtLocationTcpaAcknowledgement";
import CustomerPersonalInfo from "screens/Onboarding/SignUp/CustomerPersonalInfo/CustomerPersonalInfo";
import SignUpInterestSelection from "screens/Onboarding/SignUp/InterestSelection/InterestSelection";
import TcpaAcknowledgement from "screens/Onboarding/SignUp/TcpaAcknowledgement/TcpaAcknowledgement";
import SignUpUsageTypeSelection from "screens/Onboarding/SignUp/UsageTypeSelection/UsageTypeSelection";
import PointOfSale from "screens/PointOfSale";
import PromoCode from "screens/PromoCode";
import PurchaseComplete from "screens/PurchaseComplete";
import ChooseRewards from "screens/RedeemRewards";
import RedeemComplete from "screens/RedeemRewards/RedeemCompelte/RedeemComplete";
import RedeemConfirmation from "screens/RedeemRewards/RedeemConfirmation/RedeemConfirmation";
import WaitForBudtender from "screens/RedeemRewards/WaitForBudtender/WaitForBudtender";

export enum Routes {
  Home = "/",
  Budtender = "/budtender",
  Congrats = "/congrats",
  EditProfile = "/edit-profile",
  // TODO: differentiate, add specifity
  PurchaseComplete = "/purchase-complete",
  CompletePurchase = "/complete-purchase",
  WaitForBudtener = "/wait-for-budtender",
  // differentiate, add specifity
  Main = "/main",
  PromoCode = "/promo-code",
  RedeemRewards = "/redeem-rewards",
  RedeemConfirmation = "/redeem-confirmation",
  RedeemComplete = "/redeem-complete",
  Accept = "/accept",
  KioskWelcome = "/kiosk-welcome",
  KioskWelcomeToLocation = "/kiosk-welcome-to-location",
  AuthorizationPairing = "/pairing",
  AuthorizationManage = "/manage",
  UserInfo = "/user-info",
  // UsageTypes and InterestRoutes Onboarding
  SignUpCustomerPersonalInfo = "/customer-personal-info",
  SignUpTcpa = "/signup/tcpa",
  SignUpInterestSelection = "/signup/interests",
  SignUpUsageTypeSelection = "/signup/usage-types",

  NewAtLocationTcpaAcknowledgement = "/signup/tcpa-new-location",

  EditInterestSelection = "/edit/interests",
  EditUsageTypeSelection = "/edit/usage-types",
  EditCustomerPersonalInfo = "/edit-customer-personal-info",
  BlockchainProfile = "/blockchain-profile",
  ChangePin = "/change-pin"
}

export const UserLandRoutes = [
  Routes.Budtender,
  Routes.Congrats,
  Routes.EditProfile,
  Routes.EditInterestSelection,
  Routes.EditUsageTypeSelection,
  Routes.EditCustomerPersonalInfo,
  Routes.BlockchainProfile,
  Routes.ChangePin,
  Routes.PurchaseComplete,
  Routes.CompletePurchase,
  Routes.WaitForBudtener,
  Routes.Main,
  Routes.PromoCode,
  Routes.RedeemRewards,
  Routes.RedeemConfirmation,
  Routes.RedeemComplete
];

export const BudtenderAdministeredRoutes = [
  Routes.Budtender,
  Routes.CompletePurchase,
  Routes.WaitForBudtener,
  Routes.RedeemConfirmation
];

export const isBudtenderAdministeredRoute = (history: History) =>
  BudtenderAdministeredRoutes.includes(history.location.pathname as Routes);

const redirectUserLandRoutes = ({ location }: any) =>
  UserLandRoutes.includes(location.pathname) && <Redirect to={Routes.Home} />;

const registerAuthorizedGlobalRoutes = () => (
  <>
    <Route exact path={Routes.Accept} component={AuthorizationAccept} />
  </>
);

const registerAuthorizedPointOfSalesRoutesForNonLoggedUser = () => (
  <>
    <Route
      path={Routes.SignUpCustomerPersonalInfo}
      component={CustomerPersonalInfo}
    />
    <Route exact path={Routes.Home} component={PointOfSale} />
    <Route
      path={Routes.SignUpInterestSelection}
      component={SignUpInterestSelection}
    />
    <Route
      path={Routes.SignUpUsageTypeSelection}
      component={SignUpUsageTypeSelection}
    />
    <Route
      path={Routes.NewAtLocationTcpaAcknowledgement}
      component={NewAtLocationTcpaAcknowledgement}
    />
    <Route path={Routes.SignUpTcpa} component={TcpaAcknowledgement} />
    <Route path="*" render={redirectUserLandRoutes} />
  </>
);

const registerAuthorizedPointOfSalesRoutesForUser = () => (
  <>
    <Route exact path={Routes.Home} component={Main} />
    <Route path={Routes.Budtender} component={Budtender} />
    <Route path={Routes.Congrats} component={Congrats} />
    <Route
      path={Routes.EditInterestSelection}
      component={EditInterestSelection}
    />
    <Route
      path={Routes.EditUsageTypeSelection}
      component={EditUsageTypeSelection}
    />
    <Route
      path={Routes.EditCustomerPersonalInfo}
      component={EditCustomerPersonalInfo}
    />
    <Route path={Routes.BlockchainProfile} component={BlockchainProfile} />
    <Route path={Routes.ChangePin} component={ChangePin} />
    <Route path={Routes.PurchaseComplete} component={PurchaseComplete} />
    <Route path={Routes.CompletePurchase} component={CompletePurchase} />
    <Route path={Routes.WaitForBudtener} component={WaitForBudtender} />
    <Route path={Routes.Main} component={Main} />
    <Route path={Routes.PromoCode} component={PromoCode} />
    <Route path={Routes.RedeemRewards} component={ChooseRewards} />
    <Route path={Routes.RedeemConfirmation} component={RedeemConfirmation} />
    <Route path={Routes.RedeemComplete} component={RedeemComplete} />
  </>
);

const registerAuthorizedKioskRoutesForNonloggedUser = () => (
  <>
    <Route exact path="/" component={Kiosk} />
    <Route
      path={Routes.SignUpCustomerPersonalInfo}
      component={CustomerPersonalInfo}
    />
    <Route
      path={Routes.SignUpInterestSelection}
      component={SignUpInterestSelection}
    />
    <Route
      path={Routes.SignUpUsageTypeSelection}
      component={SignUpUsageTypeSelection}
    />
    <Route path={Routes.SignUpTcpa} component={TcpaAcknowledgement} />
    <Route
      exact
      path="/kiosk-welcome-to-location"
      component={KioskWelcomeToLocation}
    />
    <Route
      path={Routes.NewAtLocationTcpaAcknowledgement}
      component={NewAtLocationTcpaAcknowledgement}
    />
    <Route exact path={Routes.KioskWelcome} component={KioskWelcome} />
    <Route path="*" render={redirectUserLandRoutes} />
  </>
);

const AuthorizedRoutes = (props: any) => (
  <App {...props}>
    <Switch>
      <TabletDataContext.Consumer>
        {tabletData => {
          const pointOfSaleMode =
            !tabletData ||
            tabletData.operationMode === TabletOperationMode.PointOfSale;
          const kioskMode =
            tabletData &&
            tabletData.operationMode === TabletOperationMode.Kiosk;
          const tenantHasInterests = tabletData && !tabletData.hasNoInterests;
          return (
            <CustomerDataContext.Consumer>
              {userData => {
                const logged = !!userData;
                return (
                  <>
                    {registerAuthorizedGlobalRoutes()}
                    {!logged &&
                      pointOfSaleMode &&
                      registerAuthorizedPointOfSalesRoutesForNonLoggedUser()}
                    {logged &&
                      pointOfSaleMode &&
                      registerAuthorizedPointOfSalesRoutesForUser()}

                    {kioskMode &&
                      registerAuthorizedKioskRoutesForNonloggedUser()}
                  </>
                );
              }}
            </CustomerDataContext.Consumer>
          );
        }}
      </TabletDataContext.Consumer>
    </Switch>
  </App>
);

const Router = () => (
  <BrowserRouter>
    <Switch>
      <Route
        path={Routes.AuthorizationPairing}
        component={AuthorizationPairing}
      />
      <Route
        path={Routes.AuthorizationManage}
        component={AuthorizationManage}
      />
      <Route path="*" component={AuthorizedRoutes} />
    </Switch>
  </BrowserRouter>
);

export default Router;



// WEBPACK FOOTER //
// ./src/router.tsx